"use client";

import React from "react";
import {Container} from "@/shared/components/shared";
import Image from "next/image";

interface CardProps {
    imageSrc: string;
    alt: string;
    title: string;
    width: number;
    height: number;
}

const Card = ({imageSrc, alt, title, width, height}: CardProps) => {
    return (
        <div className="flex flex-col">
            <div className="relative w-full aspect-square overflow-hidden rounded-xl">
                <Image
                    src={imageSrc}
                    alt={alt}
                    width={width}
                    height={height}
                    className="object-cover w-full h-full transition-transform duration-300 hover:scale-105 cursor-pointer"
                />
            </div>
            <h3 className="text-custom-black text-lg lg:text-[32px] text-center uppercase leading-[1.2] mt-3 lg:mt-4"
                dangerouslySetInnerHTML={{__html: title}}/>
        </div>
    );
}

const cardsData = [
    {
        imageSrc: "/images/oil-change/mechanic-change-oil.jpeg",
        alt: "Механик меняет масло",
        title: "то масляный<br/> сервис",
    },
    {
        imageSrc: "/images/oil-change/tires.jpg",
        alt: "Шины",
        title: "шинный<br/> отель",
    },
    {
        imageSrc: "/images/oil-change/oil.jpeg",
        alt: "Масло",
        title: "замена<br/> тех.жидкостей",
    },
    {
        imageSrc: "/images/oil-change/winter-tire.png",
        alt: "Зимние шины",
        title: "сезонная<br/> смена шин",
    },
];

export const OilChange: React.FC = () => {
    return (
        <section>
            <Container className={'mt-14 mt-12 lg:mt-31 mb-14 lg:mb-0 lg:mb-35'}>
                <div className={'lg:text-center'}>
                    <h1 className={'text-custom-orange text-3xl font-bold lg:text-[70px] uppercase leading-[1.2]'}>
                        больше чем замена масла
                    </h1>
                    <h2 className={'text-custom-black text-2xl lg:text-[42px] uppercase mt-5 lg:mt-8 leading-[1.2]'}>
                        Это культура планового обслуживания <br className={'hidden lg:block'}/>
                        и новый стандарт города
                    </h2>
                </div>
                {/* Desktop: 4 columns */}
                <div className="hidden lg:grid grid-cols-4 gap-11 lg:mt-25">
                    {cardsData.map((card, index) => (
                        <Card key={index}
                              imageSrc={card.imageSrc}
                              title={card.title}
                              alt={card.alt}
                              width={346}
                              height={350}
                        />
                    ))}
                </div>
                
                {/* Mobile: 2 columns */}
                <div className="grid grid-cols-2 gap-4 mt-14 lg:hidden">
                    {cardsData.map((card, index) => (
                        <Card key={index}
                              imageSrc={card.imageSrc}
                              title={card.title}
                              alt={card.alt}
                              width={258}
                              height={258}
                        />
                    ))}
                </div>
            </Container>
        </section>
    );
}